(function initializeStoreLocationDistance(root, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.StoreLocationDistance = api;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, () => {
  const EARTH_RADIUS_MILES = 3958.8;

  function isCoordinate(value, minimum, maximum) {
    return Number.isFinite(value) && value >= minimum && value <= maximum;
  }

  function isPoint(value) {
    return (
      value &&
      isCoordinate(value.latitude, -90, 90) &&
      isCoordinate(value.longitude, -180, 180)
    );
  }

  function toRadians(degrees) {
    return (degrees * Math.PI) / 180;
  }

  function distanceMiles(origin, destination) {
    if (!isPoint(origin) || !isPoint(destination)) return null;

    const latitudeDifference = toRadians(destination.latitude - origin.latitude);
    const longitudeDifference = toRadians(destination.longitude - origin.longitude);
    const originLatitude = toRadians(origin.latitude);
    const destinationLatitude = toRadians(destination.latitude);
    const haversine =
      Math.sin(latitudeDifference / 2) ** 2 +
      Math.cos(originLatitude) *
        Math.cos(destinationLatitude) *
        Math.sin(longitudeDifference / 2) ** 2;
    const angularDistance = 2 * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine));

    return EARTH_RADIUS_MILES * angularDistance;
  }

  function findNearestLocation(locations, origin) {
    if (!Array.isArray(locations) || !isPoint(origin)) return null;

    return locations.reduce((nearest, location) => {
      const distance = distanceMiles(origin, location);
      if (distance === null) return nearest;

      if (!nearest || distance < nearest.distanceMiles) {
        return {
          location,
          distanceMiles: distance,
        };
      }

      return nearest;
    }, null);
  }

  function sortLocationsByDistance(locations, origin) {
    if (!Array.isArray(locations)) return [];
    if (!isPoint(origin)) return [...locations];

    return locations
      .map((location, index) => ({
        location,
        index,
        distance: distanceMiles(origin, location),
      }))
      .sort((left, right) => {
        if (left.distance === null && right.distance === null) return left.index - right.index;
        if (left.distance === null) return 1;
        if (right.distance === null) return -1;
        return left.distance - right.distance || left.index - right.index;
      })
      .map(({ location }) => location);
  }

  function formatMiles(distance) {
    if (!Number.isFinite(distance) || distance < 0) return '';
    if (distance < 0.1) return 'less than 0.1 miles';
    if (distance < 10) {
      const roundedDistance = Number(distance.toFixed(1));
      return `${roundedDistance.toFixed(1)} ${roundedDistance === 1 ? 'mile' : 'miles'}`;
    }

    const roundedDistance = Math.round(distance);
    return `${roundedDistance} ${roundedDistance === 1 ? 'mile' : 'miles'}`;
  }

  return {
    distanceMiles,
    findNearestLocation,
    formatMiles,
    sortLocationsByDistance,
  };
});
